export const retryNarIngestion = () => {
  console.log("Retry NAR ingestion");
};
